import { Button } from '@components';
import { OrgStatus } from '@constants/generic';

interface VerificationContentCardProps {
  isVerificationCompleted: boolean;
  orgStatus: OrgStatus;
  onClickResubmit: () => void;
}

const VerificationContentCard = ({
  isVerificationCompleted,
  orgStatus,
  onClickResubmit
}: VerificationContentCardProps) => {
  if (orgStatus === OrgStatus.REJECTED)
    return (
      <div className="min-w-96 rounded-xl border border-cofeeGreyBlue4 p-4 shadow-boxBorderShadow">
        <div className="text-base font-medium text-cofeeNeutral10">
          Account verification failed
        </div>
        <div className="mt-1 text-sm text-cofeeNeutral7">
          Please review and update KYC.
        </div>
        <Button
          handleClick={onClickResubmit}
          variant="primary"
          label="Re-submit"
          className="mt-4"
        />
      </div>
    );

  if (isVerificationCompleted)
    return (
      <div className="flex items-center pt-2">
        <span className="text-base font-medium text-cofeeNeutral6">
          Account verification completed
        </span>
      </div>
    );

  return (
    <div className="min-w-96 rounded-xl border border-cofeeGreyBlue4 p-4 shadow-boxBorderShadow">
      <div className="text-base font-medium text-cofeeNeutral10">
        Verification pending
      </div>
      <div className="mt-1 text-sm text-cofeeNeutral7">
        We will connect with you as soon as verification is completed.
      </div>
    </div>
  );
};

export default VerificationContentCard;
